import { formatDate } from 'utils/format_date';

export const hasMunicipalPermission = (user?: any) =>
    user?.permission?.name === 'REPRESENTANTE LEGAL MUNICIPAL';

export const hasStatePermission = (user?: any) =>
    user?.permission?.name === 'REPRESENTANTE LEGAL ESTADUAL';

export const buildTermData = (term: any) => [
    {
        label: 'Prefeitura',
        value: term?.institution?.name,
    },
    {
        label: 'Data da Assinatura - Representante Legal Municipal',
        value: formatDate(term?.legalMunicipalRepresentativeSignatureAt),
    },
    {
        label: 'Data da Assinatura - Representante Legal Estadual',
        value: formatDate(term?.legalStateRepresentativeSignatureAt),
    },
];
